"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SeatMatrixFloorSelector = function SeatMatrixFloorSelector(_ref) {
  var _ref$numberOfFloors = _ref.numberOfFloors,
      numberOfFloors = _ref$numberOfFloors === void 0 ? 1 : _ref$numberOfFloors,
      _ref$selectedFloor = _ref.selectedFloor,
      selectedFloor = _ref$selectedFloor === void 0 ? 0 : _ref$selectedFloor,
      _ref$onFloorChange = _ref.onFloorChange,
      onFloorChange = _ref$onFloorChange === void 0 ? function () {} : _ref$onFloorChange,
      t = _ref.translator;
  var floors = [];

  var _loop = function _loop(i) {
    floors.push({
      index: i,
      id: i + 1,
      onClick: function onClick() {
        return onFloorChange(i);
      }
    });
  };

  for (var i = 0; i < numberOfFloors; i += 1) {
    _loop(i);
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button.Group, {
    style: {
      marginBottom: 10
    }
  }, floors.map(function (f) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "floor_".concat(f.id)
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      onClick: f.onClick,
      active: f.index === selectedFloor
    }, t('Floor ') + f.id));
  }));
};

var _default = SeatMatrixFloorSelector;
exports["default"] = _default;